<template>
    <modal name="viewCardsModal" width="85%" height="auto" :scrollable="true" class="pt-3 pb-3">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title dashboard-card-title">View Card Deck</h4>
                <button type="button" class="btn-close" data-dismiss="modal" aria-hidden="true"
                        @click="$modal.hide('viewCardsModal')"></button>
            </div>
            <div class="modal-body" style="padding: 64px; padding-top: 40px">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <div class="title pb-1">{{ cardDeck.title }}</div>
                        <div class="card-deck-author">
                            <user-avatar :user="cardDeck.owner"></user-avatar>
                            <span class="me-2">
                                Created on {{ cardDeck.created_at | moment('DD MMM YYYY')}}<br>
                                by <b>{{ cardDeck.owner ? cardDeck.owner.name : '' }}</b>
                            </span>
                            <span class="card-deck-badge" v-if="cardDeck.cards">
                                {{  cardDeck.cards.length }} {{ cardDeck.cards === 1 ? 'card' : 'cards'}}
                            </span>
                            <span class="card-deck-badge primary">{{ cardDeck.category ? cardDeck.category.label : '' }}</span>
                        </div>
                    </div>
                    <btn v-if="!hideBtn" class="btn btn-primary" @click="$emit('onAssignCardDeck')">Share with Heroes</btn>
                </div>
                <div class="divider --top-20"></div>
                <div class="cards-list mt-2">
                    <card v-for="card in cardDeck.cards" :card="card"></card>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>

import UserAvatar from "@/components/UserAvatar.vue";
import Card from "@/components/Card.vue"

export default {
    name: 'CardDeckCardsModal',
    components: {UserAvatar, Card},
    props: ['cardDeck', 'hideBtn'],
    data() {
        return {
            loading: false,
            user: {},
        };
    },
    methods: {}
};
</script>
